import React from "react";
import parse from "html-react-parser";
import Counter from "./Counter";

const Aboutus2 = ({ data }) => {
  return (
    <div className="w-screen py-12 sm:py-16  lg:py-20 business">
      <div className="2xl:container m-auto flex flex-col lg:flex-row md:px-10 lg:px-20  gap-16 px-6">
        <div className="lg:w-1/2 w-full flex flex-col lg:items-start items-center gap-10">
          <div className="flex flex-col gap-6 lg:text-left text-center">
            <h4 className="text-24 sm:text-36 md:text-48 text-primarycolor font-semibold">
              {data.heading}
            </h4>
            <p className="text-16 sm:text-18 text-secondaryblack font-regular">
              {parse(data.desc)}
            </p>
          </div>
          <div className="flex gap-10 max-[400px]:gap-5 items-center lg:justify-between flex-wrap">
            <div className="flex flex-col gap-3 items-start justify-between text-[#5B72EE]">
              {/* <img
                className="w-[90px] h-[34px]"
                src={process.env.PUBLIC_URL + "/images/Aboutus/20+.svg"}
                alt="icon"
              /> */}
              <p
                className="font-serif text-[32px] leading-[32px] sm:text-[40px] sm:leading-[36px] font-extrabold"
                style={{
                  fontFamily: "'Libre Baskerville', serif",
                  textShadow:
                    "0.8px 0 0 currentColor, -0.8px 0 0 currentColor, 0 0.8px 0 currentColor, 0 -0.8px 0 currentColor",
                }}
              >
                20+
              </p>
              <p className="text-18 text-secondaryblack font-medium">
                Years of experience
              </p>
            </div>
            <div className="flex flex-col gap-3 items-start justify-between text-[#F48C06]">
              {/* <img
                className="w-[90px] h-[34px]"
                src={process.env.PUBLIC_URL + "/images/Aboutus/20.svg"}
                alt="icon"
              /> */}
               <p
                className="font-serif text-[32px] leading-[32px] sm:text-[40px] sm:leading-[36px] font-extrabold"
                style={{
                  fontFamily: "'Libre Baskerville', serif",
                  textShadow:
                    "0.8px 0 0 currentColor, -0.8px 0 0 currentColor, 0 0.8px 0 currentColor, 0 -0.8px 0 currentColor",
                }}
              >
                20+
              </p>
              <p className="text-18 text-secondaryblack font-medium">
                Satisfied clients
              </p>
            </div>
            <div className="flex flex-col gap-3 items-start justify-between text-[#29B9E7]">
              {/* <img
                className="w-[90px] h-[34px]"
                src={process.env.PUBLIC_URL + "/images/Aboutus/8M.svg"}
                alt="icon"
              /> */}
               <p
                className="font-serif text-[32px] leading-[32px] sm:text-[40px] sm:leading-[36px] font-extrabold"
                style={{
                  fontFamily: "'Libre Baskerville', serif",
                  textShadow:
                    "0.8px 0 0 currentColor, -0.8px 0 0 currentColor, 0 0.8px 0 currentColor, 0 -0.8px 0 currentColor",
                }}
              >
                9M+
              </p>
              <p className="text-18 text-secondaryblack font-medium">
                Successful pages
              </p>
            </div>
          </div>
        </div>
        <div className="lg:w-1/2 w-full">
          <img
            className="w-full"
            src={process.env.PUBLIC_URL + "/images/Aboutus/who-we-are.png"}
            alt="Publishing Services"
          />
        </div>
      </div>
    </div>
  );
};
export default Aboutus2;
